import type { FC } from 'react'
import UserAvatar from '../profile/user-avatar.js'
import { graphHooks } from '@tunasong/graph-lib/react'

export interface AvatarListProps {
  userIds: string[]
  size?: 'small' | 'medium' | 'large' | 'tiny'
}

/**
 * Display a list of user avatars that have access to the entity.
 */
export const AvatarList: FC<AvatarListProps> = props => {
  const { userIds, size = 'small' } = props
  const { profiles } = graphHooks.useProfiles({
    userIds,
  })
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {profiles.map(profile => (
        <UserAvatar key={profile.userId} style={{ margin: 8 }} size={size} userId={profile.userId} />
      ))}
    </div>
  )
}

export default AvatarList
